import { forwardRef } from "react"

interface SliderProps extends React.InputHTMLAttributes<HTMLInputElement> {
  value: number
  onValueChange: (value: number) => void
}

export const Slider = forwardRef<HTMLInputElement, SliderProps>(
  ({ value, onValueChange, min = 0.5, max = 2, step = 0.1, ...props }, ref) => {
    return (
      <input
        ref={ref}
        type="range"
        value={value}
        min={min}
        max={max}
        step={step}
        className="h-1 w-full appearance-none rounded-full border-none bg-bg-3 accent-primary-4"
        onChange={e => onValueChange(e.currentTarget.valueAsNumber)}
        {...props}
      />
    )
  }
)

Slider.displayName = "Slider"
